import React from 'react';
import styled, { css } from 'styled-components';

import { CategoriesMobileDisplayOption, RadiusOption } from 'types/graphql';
import { CardProps } from './card.types';

const radiusOptions = {
  [RadiusOption.rounded]: '16px',
  [RadiusOption.roundedRectangle]: '12px',
  [RadiusOption.square]: 0,
};

export const CompactCard = ({ radius, mobileDisplay, category, image, isHidden = false }: CardProps): JSX.Element => (
  <Card $radius={radius} $mobileDisplay={mobileDisplay} $hidden={isHidden}>
    <ImageWrapper>
      <img src={image} alt='' />
    </ImageWrapper>
    {category}
  </Card>
);

const Card = styled.li<{ $radius: RadiusOption; $mobileDisplay: CategoriesMobileDisplayOption; $hidden: boolean }>`
  align-items: center;
  background: #fff;
  border: 1px solid #e3e7e9;
  border-radius: ${({ $radius }) => radiusOptions[$radius]};
  color: #121516;
  display: flex;
  flex: 0 0 128px;
  flex-direction: column;
  font-size: 16px;
  font-weight: 600;
  height: 107px;
  justify-content: space-between;
  line-height: ${24 / 16};
  max-width: 148px;
  padding: 12px;
  text-align: center;
  white-space: nowrap;

  ${({ $mobileDisplay, $hidden }) =>
    $mobileDisplay === CategoriesMobileDisplayOption.grid &&
    css`
      flex: 0 0 calc(50% - 6px);
      display: ${$hidden ? 'none' : 'flex'};
    `}
`;

const ImageWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 51px;
  justify-content: center;
  overflow: hidden;
  width: 96px;

  img {
    display: block;
    max-height: 100%;
    object-fit: contain;
  }
`;
